import React from 'react';
import { twMerge } from 'tailwind-merge';

const style = {
  backgroundImage:
    'linear-gradient(90deg, #dbdbdb 0%, #f3f6f4 50% , #dbdbdb 100%)',
  backgroundSize: '400% 400%',
};

interface SkeletonProps {
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = (props) => {
  return (
    <div
      className={twMerge('h-3 rounded-lg animate-shimmer', props.className)}
      style={style}
    />
  );
};

export default Skeleton;
